import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { Collapse, Tag } from 'antd';

import { PersonaListItemDisplay } from './PersonaListItemDisplay';

export interface IPersonas {
    id: string;
    year: string;
}

export const Personas = (props: IPersonas) => {
    const { id, year } = props;
    const [personas, setPersonas] = useState<string[]>([]);

    function lookForPersonas(authorId: string, year: string) {
        axios
            .get<string[]>(`/api/look_for_personas/${id}?year=${year}`)
            .then((response) => response.data)
            .then((response) => {
                setPersonas(response);
            });
    }

    useEffect(() => {
        if (!id) return;
        lookForPersonas(id, year);
    }, [id, year]);

    return (
        <React.Fragment>
            {personas && personas.length > 1 ? (
                <Collapse defaultActiveKey={0}>
                    <Collapse.Panel header="Open to select the author's subarea you want to explore, or skip and scroll down. " key={1}>
                        <p>
                            Author personas are clusters of the author's papers, reflecting author subareas.
                            Personas are listed with some {' '}
                            <Tag color="purple">tasks</Tag>& <Tag color="blue">methods</Tag> in the cluster's papers. <b>Select one persona and scroll down to get author recommendations specific to that persona.</b>
                        </p> 
                        <PersonaRow>
                            {personas.map((persona, i) => (
                                <PersonaListItemDisplay key={i} id={persona} year={year} />
                            ))}
                        </PersonaRow>
                    </Collapse.Panel>
                </Collapse>
            ) : null}
        </React.Fragment>
    );
};

const PersonaRow = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    gap: ${({ theme }) => `${theme.spacing.md}`};
`;
